import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "supplier-forecast-dashboard" }

import { SUPPLIER_TAB_ROUTER_INFO } from '../constants';
import { useRoute } from 'vue-router';
import HeaderArea from '@/corePagesModule/components/HeaderArea.vue';
import { i18n } from '@/i18n';
import { IRouterInfo } from '@/coreDomainsModule/entities/routerInfo';


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const tabInfos = [...SUPPLIER_TAB_ROUTER_INFO];

const route = useRoute();
const t = i18n.t;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderArea, {
      title: _unref(t)('仕入先内示')
    }, null, 8, ["title"]),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabInfos, (info) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: info.router
      }, [
        (_unref(route).path === info.router)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(info.component), {
              key: 0,
              class: "supplier-forecast-dashboard__container"
            }))
          : _createCommentVNode("", true)
      ], 64))
    }), 64))
  ]))
}
}

})